import { API_URL, Home_API_TOKEN, ENV } from '../../config';

const fetchWithAuth = async (url: string) => {
    if (ENV === 'preproduction') {
        url += url.indexOf('?') > -1 ? '&publicationState=preview' : '?publicationState=preview';
    }
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${Home_API_TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const fetchHome = async (lang: string) => {
  let langpart = '';
  if (lang.indexOf('zh') > -1) {
    langpart = "&locale=zh-Hant-HK";
  }
  try {
    const homeResponse = await fetchWithAuth(
      `${API_URL}/home?pagination[limit]=-1&populate=Announcement,HomepageBanner.CustomerTypeDisplay,HomepageBanner.Image,HomepageBanner.ImageTablet,
      HomepageBanner.ImageMobile,HomepageBanner.TitleArt,HomepageBanner.DesktopChannelLogo,HomepageBanner.MobileChannelLogo,HomepageBanner.Button,
      HomepageBanner.Html5Video,FeaturedSection.CustomerTypeDisplay,FeaturedSection.BackgroundImage,FeaturedSection.BackgroundImageTablet,
      FeaturedSection.BackgroundImageMobile,FeaturedSection.ChannelLogo,FeaturedSection.Button,FeaturedSection.Html5Video,FeaturedSection.FeaturedImage,
      FeaturedSection.Link,FeaturedSection.SplitTemplateContent.BackgroundImage,FeaturedSection.SplitTemplateContent.ChannelLogo,
      FeaturedSection.SplitTemplateContent.Html5Video,FeaturedSection.SplitTemplateContent.BottomImage,SEO.MetaImage,GA ` + langpart
    );

    console.log('homeResponse API Response:', homeResponse);
    return homeResponse;
  } catch (error) {
    console.error('Error fetching packs.', error);
    return null;
  }
};